import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  VictoryArea,
  VictoryChart,
  VictoryVoronoiContainer,
  VictoryTooltip,
} from "victory";
import { Grid, useMediaQuery } from "@material-ui/core";
import {
  primary,
  black,
  messagesBackground,
} from "../../../assets/variables.module.scss";
import useStyles from "./styles";

export default function LineChartBlock({ data, LabelComponent }) {
  const isLG = useMediaQuery("(min-width:1400px)");
  const isXL = useMediaQuery("(min-width:1900px)");

  const findContainerHeight = () => {
    if (isXL) {
      return 41;
    }
    if (isLG) {
      return 45;
    }
    return 50;
  };

  const { container } = useStyles({ containerHeight: findContainerHeight() });

  if (!data) return null;

  return (
    <Grid item container xs={12} className={container}>
      {data?.values.length > 0 && (
        <VictoryChart
          width={1200}
          height={300}
          containerComponent={<VictoryVoronoiContainer />}
        >
          <VictoryArea
            labels={({ datum }) => datum.x}
            labelComponent={
              <VictoryTooltip
                flyoutStyle={{
                  stroke: "none",
                  fill: messagesBackground,
                }}
                labelComponent={LabelComponent && <LabelComponent />}
                flyoutHeight={90}
                flyoutWidth={90}
              />
            }
            style={{
              data: {
                fill: primary,
              },
              labels: { fill: black },
            }}
            domain={data?.domain}
            categories={{
              x: data?.categories.x.map((date) => {
                const formattedDate = moment(date)
                  .add(1, "M")
                  .format("MMM YYYY")
                  .replace(".", "");
                return (
                  formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
                );
              }),
            }}
            data={data?.values.map(({ x, y, ...rest }) => {
              const formattedDate = moment(x)
                .add(1, "M")
                .format("MMM YYYY")
                .replace(".", "");
              return {
                x:
                  formattedDate.charAt(0).toUpperCase() +
                  formattedDate.slice(1),
                y,
                ...rest,
              };
            })}
          />
        </VictoryChart>
      )}
    </Grid>
  );
}

LineChartBlock.defaultProps = {
  LabelComponent: undefined,
};
LineChartBlock.propTypes = {
  data: PropTypes.object.isRequired,
  LabelComponent: PropTypes.func,
};
